// import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import logoSymbolImage from "../../assets/images/HindusRUsIcon.png";
import fullLogoImage from "../../assets/images/HindusRUsFullLogo.png";

const SidebarLogo = ({ InSidebar = true, InHeader = false }) => {
  let isTabletLayout = useMediaQuery("(max-width:780px)");

  if (InSidebar) {
    return (
      <div className="px-1 py-2 d-flex justify-content-center mt-1">
        <Link to="/">
          <img src={fullLogoImage} alt="HindusRUs Logo" style={{ height: 50 }} />
        </Link>
      </div>
    );
  } else if (InHeader && isTabletLayout) {
    return (
      <div className="me-2 d-flex justify-content-center">
        <Link to="/">
          <img src={logoSymbolImage} alt="HindusRUs Logo" style={{ height: 50 }} />
        </Link>
      </div>
    );
  } else {
    return null;
  }
};

export default SidebarLogo;
